module.exports = __webpack_public_path__ + "static/media/ic_link_black_24px.311af7f9.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Card/ic_link_black_24px.svg
 ** module id = 177
 ** module chunks = 0
 **/